import styled from 'styled-components';
export const TitleWrapper = styled.div `
  text-align: center;
`;
export const TitleGraph = styled.span `
  font-size: 16px;
  font-color: ${({ theme }) => theme.titlePageFontColor};
`;
export const SubTitleGraph = styled.span `
  font-size: 12px;
`;
